/**
 * Реквизиты продавца.
 *
 * Держим в ядре, а не в текстах интерфейса: они нужны и на юридических
 * страницах, и в чеке, и в заявке банку. Дублировать их по локалям нельзя —
 * реквизиты одни и те же на любом языке.
 */
export const MERCHANT = {
    /** Как записано в уведомлении о регистрации ИП. */
    name: 'ИП «Kerderi.kz»',
    owner: 'Рысқалиұлы Айбек',
    bin: '920709350469',
    /** Юридический адрес из уведомления о регистрации. */
    address: 'Республика Казахстан, Акмолинская область, г. Косшы, ул. Достык, 47',
    phone: '+7 776 122-76-67',
    /** Тот же номер без разделителей — для ссылки tel:, сайт открывают с телефона. */
    phoneTel: '+77761227667',
    /** Тот же номер для wa.me — там номер без плюса и разделителей. */
    whatsapp: '77761227667',
    /** Официальный ящик: реквизиты, оферта, запросы от банка и модерации. */
    email: 'info@neke-test.kz',
    /**
     * Куда пишет пользователь: оплата, доступ к отчёту, возврат, удаление
     * данных. Отделён от info@, чтобы обращения не тонули среди переписки
     * с банком, — на этот ящик мы обещаем ответ за один рабочий день.
     */
    support: 'support@neke-test.kz',
    /** Всё остальное: партнёрство, пресса, предложения. */
    hello: 'hello@neke-test.kz',
    site: 'neke-test.kz',
    /** Дата последней редакции юридических документов. */
    documentsUpdated: '2026-08-23',
};
/** Реквизиты неполны, пока не заполнен телефон — модерация его требует. */
export const merchantReady = Boolean(MERCHANT.phone && MERCHANT.email);
//# sourceMappingURL=legal.js.map